module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-unknown-1.f4b66323.svg";